"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardBlockLibrary = exports.SortItemTelemetryLabelMap = exports.createNewOptionItems = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var block_video_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-video-75.svg"));
var block_text_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-text-75.svg"));
var block_image_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-image-75.svg"));
var block_embed_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-embed-75.svg"));
var block_quote_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-quote-75.svg"));
var block_accept_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/block-accept-75.svg"));
var dashboard_empty_arrow_svg_1 = __importDefault(require("@ClientAssets/icons/brand/dashboard-empty-arrow.svg"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SavedBlockCard_1 = require("Dashboard/DashboardBlockLibrary/SavedBlockCard");
var SortBySelector_1 = __importStar(require("Dashboard/SortBySelector/SortBySelector"));
var DashboardTypes_1 = require("Dashboard/DashboardTypes");
var mobx_1 = require("mobx");
var SavedBlockViewStore_1 = require("SavedBlock/SavedBlockViewStore");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var SavedBlockFilterSelector_1 = __importDefault(require("SavedBlock/SavedBlockFilterSelector/SavedBlockFilterSelector"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var FolderNameInput_1 = require("Dashboard/FolderNameInput/FolderNameInput");
var Sidebar_1 = require("Dashboard/Sidebar/Sidebar");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
var DashboardTypes_2 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DragLabel_1 = __importDefault(require("Dashboard/DragLabel/DragLabel"));
var StringManipulater_1 = require("Utils/StringManipulater");
var SetDragImage_1 = require("Dashboard/SetDragImage");
var Checkbox_1 = require("Dashboard/ActionTray/Checkbox");
var SelectAllCheckbox_1 = __importDefault(require("Dashboard/ActionTray/SelectAllCheckbox"));
var StaggeredAnimation_1 = require("Dashboard/Layout/StaggeredAnimation");
var kaleidoscope_5 = require("@qwilr/kaleidoscope");
var GhostSavedBlockItem_1 = __importDefault(require("Dashboard/DashboardBlockLibrary/SavedBlockCard/GhostSavedBlockItem"));
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var BASE_CLASS_NAME = "dashboard-block-library";
exports.createNewOptionItems = [
    { title: "Text Block", blockType: BlockTypes_1.BlockType.Text },
    { title: "Splash Block", blockType: BlockTypes_1.BlockType.Splash },
    { title: "Video Block", blockType: BlockTypes_1.BlockType.Video },
    { title: "Quote Block", blockType: BlockTypes_1.BlockType.Quote },
    { title: "Accept Block", blockType: BlockTypes_1.BlockType.Accept },
    { title: "Embed Block", blockType: BlockTypes_1.BlockType.Source },
];
exports.SortItemTelemetryLabelMap = (_a = {},
    _a[SortBySelector_1.MenuItem.Created] = "date created",
    _a[SortBySelector_1.MenuItem.Name] = "alphabetical",
    _a);
var DashboardBlockLibrary = (function (_super) {
    __extends(DashboardBlockLibrary, _super);
    function DashboardBlockLibrary(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectFolder = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var _a, savedBlocksFolderViewStore, viewStore;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, savedBlocksFolderViewStore = _a.savedBlocksFolderViewStore, viewStore = _a.viewStore;
                        if (id === savedBlocksFolderViewStore.folderSelectionStore.selectedFolder) {
                            return [2];
                        }
                        savedBlocksFolderViewStore.folderSelectionStore.setSelectedFolder(id);
                        viewStore.clearSelectedBlocks();
                        return [4, viewStore.filterSavedBlocksByFolderId(id)];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        }); };
        _this.dropOnFolder = function (event, folderId) { return __awaiter(_this, void 0, void 0, function () {
            var _a, savedBlocksFolderViewStore, viewStore, dragData, rawDragData, folderToMove, _b, _c, blockId, e_1_1;
            var e_1, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.props, savedBlocksFolderViewStore = _a.savedBlocksFolderViewStore, viewStore = _a.viewStore;
                        rawDragData = event.dataTransfer.getData("application/json");
                        try {
                            dragData = JSON.parse(rawDragData);
                        }
                        catch (e) {
                        }
                        if (!!!dragData) return [3, 10];
                        if (dragData.type === DashboardTypes_1.DragDataType.SidebarFolder) {
                            folderToMove = dragData.folderToMove;
                            savedBlocksFolderViewStore.moveFolder(folderToMove, folderId);
                            return [2];
                        }
                        if (viewStore.selectedBlockIndexes.length === 0 || viewStore.isSameFolder(folderId)) {
                            return [2];
                        }
                        return [4, savedBlocksFolderViewStore.moveResourceToFolder(viewStore.selectedBlockIds, folderId)];
                    case 1:
                        _e.sent();
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 7, 8, 9]);
                        _b = __values(viewStore.selectedBlockIds), _c = _b.next();
                        _e.label = 3;
                    case 3:
                        if (!!_c.done) return [3, 6];
                        blockId = _c.value;
                        return [4, viewStore.moveBlockToFolder(blockId, folderId)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3, 3];
                    case 6: return [3, 9];
                    case 7:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 9:
                        viewStore.clearSelectedBlocks();
                        _e.label = 10;
                    case 10: return [2];
                }
            });
        }); };
        _this.createNewFolder = function (accountLevel) {
            if (accountLevel === void 0) { accountLevel = false; }
            var savedBlocksFolderViewStore = _this.props.savedBlocksFolderViewStore;
            if (savedBlocksFolderViewStore && savedBlocksFolderViewStore.allowCreatingFolder) {
                savedBlocksFolderViewStore.startCreatingFolder(accountLevel);
            }
        };
        _this.handleDeleteFolder = function (folderToDelete) { return __awaiter(_this, void 0, void 0, function () {
            var savedBlocksFolderViewStore, selectedFolderWasDeleted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        savedBlocksFolderViewStore = this.props.savedBlocksFolderViewStore;
                        return [4, savedBlocksFolderViewStore.onDeleteFolder(folderToDelete)];
                    case 1:
                        selectedFolderWasDeleted = _a.sent();
                        if (!selectedFolderWasDeleted) return [3, 3];
                        return [4, this.onSelectFolder(DashboardTypes_2.SavedBlockCollection.All)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        _this.renderGhosts = function () {
            return (react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "ghosts-staggered-transition", delayInMs: 50, transitionTimeoutInMs: kaleidoscope_5.AnimationDuration.Long, disableLeaveAnimation: true }, __spreadArray([], __read(Array(6).keys()), false).map(function (value, i) { return (react_1.default.createElement("div", { className: "ghost-block-items", key: i },
                react_1.default.createElement(GhostSavedBlockItem_1.default, null),
                react_1.default.createElement(GhostSavedBlockItem_1.default, null))); })));
        };
        _this.getFolderName = function (folderId) {
            if ((0, DashboardUtils_1.isASystemFolder)(folderId)) {
                return (0, DashboardUtils_1.getBlockFolderTitle)(folderId);
            }
            return _this.props.savedBlocksFolderViewStore.getFolderName(_this.props.savedBlocksFolderViewStore.folderSelectionStore.selectedFolder);
        };
        _this.renderTopControls = function () {
            var savedBlocksFolderViewStore = _this.props.savedBlocksFolderViewStore;
            var folderSelectionStore = savedBlocksFolderViewStore.folderSelectionStore, foldersDataStore = savedBlocksFolderViewStore.foldersDataStore;
            var selectedFolder = folderSelectionStore.selectedFolder;
            var disabled = (0, DashboardUtils_1.isASystemFolder)(folderSelectionStore.selectedFolder);
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__left-controls") },
                    react_1.default.createElement(FolderNameInput_1.FolderNameInput, { key: selectedFolder, isDisabled: disabled, folderName: _this.getFolderName(selectedFolder), folderId: selectedFolder, changeFolderName: disabled ? undefined : foldersDataStore.updateFolderName, maxLength: 100 })),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__right-controls") },
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__search") },
                        react_1.default.createElement(kaleidoscope_1.SearchInput, { label: "Search saved blocks", placeholder: "Search saved blocks", onChange: _this.onSearchTermChange, value: _this.props.viewStore.searchTerm, onClear: _this.onSearchTermClear })),
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__option-menu") },
                        react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "".concat(BASE_CLASS_NAME, "__create-menu"), size: "small", button: react_1.default.createElement(kaleidoscope_1.Button, { decorator: kaleidoscope_1.ButtonDecorator.Dropdown }, "Create new") }, exports.createNewOptionItems
                            .filter(function (f) { return !_this.props.hiddenCreateOptions.includes(f.blockType); })
                            .map(function (_a) {
                            var blockType = _a.blockType, title = _a.title;
                            return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: blockType, onClick: _this.onCreateNew(blockType) }, title));
                        }))))));
        };
        _this.renderActionRow = function () {
            if (_this.props.viewStore.selectedBlockIndexes.length === 0) {
                return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__filters-and-sort") },
                    react_1.default.createElement(SavedBlockFilterSelector_1.default, { savedBlockViewStore: _this.props.viewStore, telemetry: _this.props.telemetry, compactButton: false, telemetryContext: TelemetryEnums_1.SavedBlockOrigin.Dashboard }),
                    react_1.default.createElement(SortBySelector_1.default, { menuAssets: SavedBlockViewStore_1.sortMenuAssets, selectedMenuItem: _this.props.viewStore.getSelectedSortMenuItem(), onSelectMenuItemHandle: _this.onSelectSortMenuItemHandle, sortDirection: _this.props.viewStore.sortDirection })));
            }
            return (react_1.default.createElement("div", { key: "right-actions__action-icons", className: "dashboard-action-tray__right-inner right-actions__action-icons" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_2.IconButton, { icon: react_1.default.createElement(icons_1.Delete, null), onClick: _this.deleteBlocks, buttonState: kaleidoscope_2.ButtonState.Idle, size: kaleidoscope_2.ButtonSize.Small, tooltip: {
                            content: "Delete",
                            position: kaleidoscope_2.TooltipPosition.Bottom,
                        } }))));
        };
        _this.toggleBlockSelection = function (blockId, event, index) {
            if (event.shiftKey) {
                _this.props.viewStore.rangeSelect(index);
            }
            else {
                _this.props.viewStore.toggleBlockSelection(index);
            }
        };
        _this.renderSavedBlockList = function () {
            var _a = _this.props, userIsAdmin = _a.userIsAdmin, viewStore = _a.viewStore, usingFeature = _a.usingFeature;
            return (react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "saved-blocks-staggered-transition", delayInMs: 50, disableLeaveAnimation: true, transitionTimeoutInMs: kaleidoscope_5.AnimationDuration.Long }, viewStore.savedBlocks.map(function (block, index) {
                var selected = viewStore.isBlockSelected(index);
                return (react_1.default.createElement("div", { draggable: true, onDragStart: function (e) { return _this.resourceDragStart(e, index); }, key: block.id, className: "".concat(BASE_CLASS_NAME, "__saved-block-item") },
                    react_1.default.createElement(SavedBlockCard_1.SavedBlockCard, { enableSelection: true, isSelected: selected, toggleSelection: function (blockId, event) { return _this.toggleBlockSelection(blockId, event, index); }, parentFolder: block.parentFolder, blockType: block.type, name: block.savedBlockName, editingIsLockedToAdmins: block.$editingLockedToAdmins, userIsAdmin: userIsAdmin, blockId: block.id, createdAt: (0, CommonUtils_1.convertTimeStringToDateString)(block.createdAt), onDeleteClick: function () {
                            viewStore.deleteSavedBlock(block.id);
                        }, onEditClick: function () {
                            _this.openSavedBlockInEditor(block.id, "edit");
                        }, onPreviewClick: function () {
                            _this.openSavedBlockInEditor(block.id, "preview");
                        }, onClick: function () {
                            _this.openSavedBlockInEditor(block.id, "preview");
                        }, onToggleEditingIsLockedToAdmins: function () {
                            _this.setLockEditingSettingForSavedBlock(block.id, !block.$editingLockedToAdmins);
                        }, isUsingThumbnails: false, canEditQuoteV1: usingFeature(FeatureFlag_1.default.CanEditQuoteV1) })));
            })));
        };
        _this.renderEmptySearchResult = function () {
            return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__empty-search-result") },
                react_1.default.createElement(kaleidoscope_2.EmptyState, { title: "There's nothing here!", subtitle: "We couldn't find any saved blocks with that name.", isDashed: true })));
        };
        _this.renderGroupOfBlockTypeIcons = function () {
            return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__all-block-type-icons") }, [block_text_75_svg_1.default, block_image_75_svg_1.default, block_video_75_svg_1.default, block_embed_75_svg_1.default, block_quote_75_svg_1.default, block_accept_75_svg_1.default].map(function (icon) {
                return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__block-type-icon"), key: icon },
                    react_1.default.createElement(kaleidoscope_2.SVG, { src: icon })));
            })));
        };
        _this.renderEmptyBlockList = function () {
            return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__empty-block-list") },
                react_1.default.createElement(kaleidoscope_2.EmptyState, { title: "Build pages faster", subtitle: "Save your favorite blocks of content to your Block Library, then add them to any page with just a few clicks.", isDashed: true, image: _this.renderGroupOfBlockTypeIcons() },
                    react_1.default.createElement(kaleidoscope_2.SVG, { src: dashboard_empty_arrow_svg_1.default, className: "".concat(BASE_CLASS_NAME, "__empty-block-list-arrow") }))));
        };
        _this.renderMainPanel = function () {
            var _a;
            if (((_a = _this.props.viewStore.savedBlocks) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return _this.renderSavedBlockList();
            }
            if (_this.props.viewStore.searchTerm) {
                return _this.renderEmptySearchResult();
            }
            return _this.renderEmptyBlockList();
        };
        _this.setLockEditingSettingForSavedBlock = function (id, newState) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.viewStore.setLockEditingSettingForSavedBlock(id, newState)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.onSearchTermChange = function (searchTerm) {
            var filtersForTelemetry = __spreadArray([], __read(_this.props.viewStore.selectedBlockTypeFilterList), false);
            if (!!searchTerm) {
                filtersForTelemetry.push("search");
            }
            _this.props.telemetry.debouncedTrack("Saved Block Library Filtered", {
                saved_block_origin: TelemetryEnums_1.SavedBlockOrigin.Dashboard,
                saved_block_library_filtered_by: filtersForTelemetry.join(", "),
            }, {}, 5000);
            _this.props.viewStore.setSearchTerm(searchTerm);
        };
        _this.onSearchTermClear = function () {
            _this.props.viewStore.setSearchTerm("");
        };
        _this.openSavedBlockInEditor = function (entityId, action) {
            var currentLibraryStates = _this.props.viewStore.currentSearchAndFilterStates;
            var currentFolder = _this.props.viewStore.currentFolder;
            _this.props.dashboardController.$state.go("savedBlock", {
                entityId: entityId,
                action: action,
                currentFolder: currentFolder,
            }, {
                location: false,
            });
            _this.returnToBlockLibrary(__assign(__assign({}, currentLibraryStates), { currentFolder: currentFolder }));
        };
        _this.onCreateNew = function (blockType) { return function () {
            _this.openSavedBlockInEditor(blockType, "new");
        }; };
        _this.returnToBlockLibrary = function (_a) {
            var searchTerm = _a.searchTerm, filterList = _a.filterList, currentFolder = _a.currentFolder;
            setTimeout(function () {
                _this.props.dashboardController.$state.go("dashboard", {
                    nav: "blocks",
                    savedBlockParams: { searchTerm: searchTerm, filterList: filterList, currentFolder: currentFolder },
                }, {
                    location: "replace",
                });
            }, 500);
        };
        _this.onSelectSortMenuItemHandle = function (sortBy, sortDirection) {
            var viewStore = _this.props.viewStore;
            viewStore.onSelectSortMenuItemHandle(sortBy, sortDirection);
            var selectedSortMenuAsset = viewStore.getSelectedSortMenuItem();
            if (exports.SortItemTelemetryLabelMap[selectedSortMenuAsset]) {
                _this.props.telemetry.trackOnly("Saved Block Library Sorted", {
                    saved_block_origin: TelemetryEnums_1.SavedBlockOrigin.Dashboard,
                    saved_block_library_sorted_by: exports.SortItemTelemetryLabelMap[selectedSortMenuAsset],
                });
            }
        };
        _this.deleteBlocks = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.props.viewStore.selectedBlockIndexes.length === 0) {
                            return [2];
                        }
                        return [4, this.props.viewStore.bulkDelete()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.projectDragLabelRef = react_1.default.createRef();
        return _this;
    }
    DashboardBlockLibrary.prototype.onFolderDragStart = function (event, folderId) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.SidebarFolder,
            folderToMove: folderId,
        };
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
    };
    DashboardBlockLibrary.prototype.resourceDragStart = function (event, index) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.ResourceCards,
        };
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
        (0, SetDragImage_1.setDragImage)(event, this.projectDragLabelRef.current);
        if (!this.props.viewStore.isBlockSelected(index)) {
            this.props.viewStore.addBlock(index);
        }
    };
    DashboardBlockLibrary.prototype.render = function () {
        var _this = this;
        var _a = this.props, savedBlocksFolderViewStore = _a.savedBlocksFolderViewStore, viewStore = _a.viewStore;
        var folderSelectionStore = savedBlocksFolderViewStore.folderSelectionStore, accountFolderViewStore = savedBlocksFolderViewStore.accountFolderViewStore;
        var selectedFolder = folderSelectionStore.selectedFolder;
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, " dashboard__container") },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, " dashboard__content") },
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__sidebar dashboard__sidebar") },
                    react_1.default.createElement("div", { className: "dashboard__sidebar-container" },
                        react_1.default.createElement("div", { className: "dashboard-sidebar" },
                            react_1.default.createElement(Sidebar_1.SidebarHeading, { title: "Account Folders", addFolderButtonName: "Create account folder", onAddFolderClick: function () { return _this.createNewFolder(true); }, allowCreatingFolder: savedBlocksFolderViewStore.allowCreatingFolder }),
                            react_1.default.createElement("div", { onMouseDown: function (e) {
                                    e.stopPropagation();
                                } },
                                react_1.default.createElement(kaleidoscope_3.FolderTree, { className: "dashboard-sidebar__my-folders", onDragStart: this.onFolderDragStart, onCreateFolder: savedBlocksFolderViewStore.onCreateChildFolder, onNameChange: savedBlocksFolderViewStore.onNameChange, onRenameConfirm: savedBlocksFolderViewStore.onRenameConfirm, onRenameCancel: savedBlocksFolderViewStore.onRenameCancel, onDeleteFolder: this.handleDeleteFolder, onDropOnFolder: this.dropOnFolder, viewStore: accountFolderViewStore, onSelect: this.onSelectFolder })),
                            react_1.default.createElement(Sidebar_1.SystemFolder, { dragDropOnFolder: this.dropOnFolder, name: (0, DashboardUtils_1.getBlockFolderTitle)(DashboardTypes_2.SavedBlockCollection.All), collection: DashboardTypes_2.SavedBlockCollection.All, onFolderSelect: this.onSelectFolder, active: selectedFolder === DashboardTypes_2.SavedBlockCollection.All, icon: react_1.default.createElement(icons_1.Folder, null) })))),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__main dashboard__main") },
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__controls"), onMouseDown: function (event) { return event.stopPropagation(); } }, this.renderTopControls()),
                    react_1.default.createElement("div", { onMouseDown: function (event) { return event.stopPropagation(); }, className: "".concat(BASE_CLASS_NAME, "__action-row dashboard-sticky-action-row") },
                        react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__action-row-inner dashboard__action-row-inner") },
                            react_1.default.createElement("div", { className: "dashboard-action-tray" },
                                react_1.default.createElement("div", { className: "dashboard-action-tray__left" },
                                    react_1.default.createElement(SelectAllCheckbox_1.default, { resourceLabel: "block", toggleClick: this.props.viewStore.toggleSelectAllBlocks, selectionState: this.selectionState, numSelectedProjects: this.props.viewStore.selectedBlockIndexes.length })),
                                react_1.default.createElement("div", { className: "dashboard-action-tray__right center" }, this.renderActionRow())))),
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__main-panel") },
                        react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__saved-block-list") },
                            react_1.default.createElement(ReactCSSTransitionGroup, { transitionLeave: true, transitionLeaveTimeout: kaleidoscope_5.AnimationDuration.Medium, transitionName: "saved-blocks-list-transition", transitionEnter: false, component: react_1.default.Fragment }, viewStore.isLoading ? this.renderGhosts() : this.renderMainPanel()))),
                    this.renderProjectDragLabel))));
    };
    Object.defineProperty(DashboardBlockLibrary.prototype, "selectionState", {
        get: function () {
            var viewStore = this.props.viewStore;
            if (viewStore.isAllSelected) {
                return Checkbox_1.CheckboxState.All;
            }
            if (viewStore.selectedBlockIndexes.length === 0) {
                return Checkbox_1.CheckboxState.None;
            }
            return Checkbox_1.CheckboxState.Some;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DashboardBlockLibrary.prototype, "renderProjectDragLabel", {
        get: function () {
            return (react_1.default.createElement("div", { className: "dashboard__drag-label" },
                react_1.default.createElement(DragLabel_1.default, { divRef: this.projectDragLabelRef, text: (0, StringManipulater_1.pluralise)(this.props.viewStore.selectedBlockIndexes.length, "block") })));
        },
        enumerable: false,
        configurable: true
    });
    var _b, _c, _d, _e, _f;
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _b : Object, typeof (_c = typeof kaleidoscope_4.FolderTreeId !== "undefined" && kaleidoscope_4.FolderTreeId) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], DashboardBlockLibrary.prototype, "onFolderDragStart", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "onSelectFolder", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _d : Object, Number]),
        __metadata("design:returntype", void 0)
    ], DashboardBlockLibrary.prototype, "resourceDragStart", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof Checkbox_1.CheckboxState !== "undefined" && Checkbox_1.CheckboxState) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], DashboardBlockLibrary.prototype, "selectionState", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_f = typeof react_1.default !== "undefined" && react_1.default.ReactElement) === "function" ? _f : Object),
        __metadata("design:paramtypes", [])
    ], DashboardBlockLibrary.prototype, "renderProjectDragLabel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "toggleBlockSelection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "setLockEditingSettingForSavedBlock", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "onSearchTermChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "onSearchTermClear", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "openSavedBlockInEditor", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "onCreateNew", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DashboardBlockLibrary.prototype, "onSelectSortMenuItemHandle", void 0);
    DashboardBlockLibrary = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], DashboardBlockLibrary);
    return DashboardBlockLibrary;
}(react_1.default.Component));
exports.DashboardBlockLibrary = DashboardBlockLibrary;
